export default __webpack_public_path__ + "static/media/gtav.53fbca51.jpg";